
import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '¿Cómo puedo realizar el pago de mi deuda en línea?',
      answer: 'Para realizar el pago de tu deuda en línea, haz clic en el botón "Ir a Pagar Ahora" en la sección de pagos. Serás redirigido a nuestra plataforma segura donde podrás ingresar tus datos y completar el pago con tarjeta de crédito, débito o PSE.',
      icon: 'ri-question-line'
    },
    {
      question: '¿Qué medios de pago están disponibles?',
      answer: 'Aceptamos múltiples medios de pago incluyendo tarjetas de crédito (Visa, Mastercard, American Express), tarjetas débito y PSE (Pagos Seguros en Línea) para transferencias bancarias directas desde tu cuenta.',
      icon: 'ri-bank-card-2-line'
    },
    {
      question: '¿Cuánto tiempo tarda en verse reflejado mi pago?',
      answer: 'Los pagos realizados con tarjeta de crédito o débito se reflejan de forma inmediata. Los pagos realizados mediante PSE pueden tardar entre 1 y 2 días hábiles en verse reflejados en tu cuenta. Te recomendamos guardar el comprobante de pago.',
      icon: 'ri-time-line'
    },
    {
      question: '¿Es seguro pagar a través de este enlace?',
      answer: 'Sí, es completamente seguro. Utilizamos la plataforma AvalPayCenter, una pasarela de pagos certificada y encriptada que cumple con los más altos estándares de seguridad PCI DSS. Todos tus datos están protegidos y encriptados.',
      icon: 'ri-shield-check-line'
    },
    {
      question: '¿A quién puedo contactar si tengo un problema con mi pago?',
      answer: 'Si tienes algún problema con tu pago, puedes contactarnos a través de nuestros teléfonos (601) 7942180, (601) 7944007, (601) 7941992, por WhatsApp al +57 318 336 5407, o enviarnos un correo a Cobranzas@cash24-7.co. Nuestro equipo te atenderá de lunes a viernes de 8:00 a.m. a 6:00 p.m. y sábados de 8:00 a.m. a 3:00 p.m.',
      icon: 'ri-customer-service-line'
    },
    {
      question: '¿Puedo hacer abonos parciales a mi deuda?',
      answer: 'Sí, puedes realizar abonos parciales a tu deuda. Cada pago que realices se aplicará al saldo pendiente de tu obligación. Te recomendamos contactarnos para conocer el estado actualizado de tu deuda y acordar un plan de pagos que se ajuste a tu capacidad.',
      icon: 'ri-money-dollar-circle-line'
    },
    {
      question: '¿Qué debo hacer después de realizar el pago?',
      answer: 'Después de realizar el pago, guarda el comprobante que te envía la plataforma. Si deseas confirmar que tu pago fue recibido correctamente, puedes contactarnos con el número de transacción y te confirmaremos la aplicación del pago a tu cuenta.',
      icon: 'ri-file-list-3-line'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center w-24 h-24 bg-gray-800 rounded-full mx-auto mb-6">
              <i className="ri-question-answer-line text-5xl text-white"></i>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
              Preguntas Frecuentes
            </h2>
            <div className="w-24 h-1 bg-gray-800 mx-auto mb-8"></div>
            <p className="text-xl text-gray-700">
              Encuentra respuestas a las preguntas más comunes sobre pagos y nuestros servicios
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div 
                key={index}
                className="bg-gray-50 rounded-lg overflow-hidden border-2 border-transparent hover:border-gray-800 transition-all"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full px-6 py-5 flex items-center justify-between gap-4 text-left cursor-pointer"
                >
                  <div className="flex items-center gap-4 flex-1">
                    <div className="flex items-center justify-center w-10 h-10 bg-gray-800 rounded-full flex-shrink-0">
                      <i className={`${faq.icon} text-xl text-white`}></i>
                    </div>
                    <span className="font-bold text-lg text-black pr-4">{faq.question}</span>
                  </div>
                  <i className={`ri-arrow-down-s-line text-2xl text-gray-800 flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`}></i>
                </button>
                {openIndex === index && (
                  <div className="px-6 pb-5 pl-20">
                    <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-12 bg-gray-50 p-8 rounded-lg border-2 border-gray-800">
            <div className="text-center">
              <div className="flex items-center justify-center w-16 h-16 bg-gray-800 rounded-full mx-auto mb-4">
                <i className="ri-customer-service-2-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-black mb-4">¿Tienes más preguntas?</h3>
              <p className="text-gray-700 mb-6">
                Nuestro equipo está listo para ayudarte. Contáctanos y resolveremos todas tus dudas.
              </p>
              <a 
                href="/#contacto"
                className="inline-block bg-gray-800 hover:bg-gray-900 text-white px-8 py-3 rounded-lg font-bold transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                Contactar Ahora
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
